export const SCHEMA_TYPES = {
  HOTEL: 'Hotel',
  OFFER: 'Offer',
  LODGING_RESERVATION: 'LodgingReservation',
  COMPOUND_PRICE_SPECIFICATION: 'CompoundPriceSpecification',
  UNIT_PRICE_SPECIFICATION: 'UnitPriceSpecification',
  POSTAL_ADDRESS: 'PostalAddress',
} as const

interface PriceComponent {
  '@type': typeof SCHEMA_TYPES.UNIT_PRICE_SPECIFICATION
  name: string
  price: number
  priceCurrency: string
  priceComponentType?: string
}

interface PriceSpecification {
  '@type': typeof SCHEMA_TYPES.COMPOUND_PRICE_SPECIFICATION
  price: number
  priceCurrency: string
  priceComponent: Array<PriceComponent>
}

interface MakesOffer {
  '@type': [typeof SCHEMA_TYPES.OFFER, typeof SCHEMA_TYPES.LODGING_RESERVATION]
  checkinTime: string
  checkoutTime: string
  priceSpecification: PriceSpecification
}

const roundPrice = (price: number | undefined): number => {
  return price ? Math.round(price) : 0
}

/** The figures one `makesOffer` entry advertises. `offerPrice` is inclusive of the other three. */
export interface OfferStructuredDataPrice {
  offerPrice: number
  offerPriceBeforeTax?: number
  taxesAndFees?: number
  propertyFees?: number
}

export const createOfferStructuredData = (
  checkIn: string,
  checkOut: string,
  primaryPrice: OfferStructuredDataPrice,
  currency: string,
): MakesOffer => ({
  '@type': [SCHEMA_TYPES.OFFER, SCHEMA_TYPES.LODGING_RESERVATION],
  checkinTime: checkIn,
  checkoutTime: checkOut,
  priceSpecification: {
    '@type': SCHEMA_TYPES.COMPOUND_PRICE_SPECIFICATION,
    price: roundPrice(primaryPrice.offerPrice),
    priceCurrency: currency,
    priceComponent: [
      {
        '@type': SCHEMA_TYPES.UNIT_PRICE_SPECIFICATION,
        name: '',
        price: roundPrice(primaryPrice.offerPriceBeforeTax),
        priceCurrency: currency,
      },
      {
        '@type': SCHEMA_TYPES.UNIT_PRICE_SPECIFICATION,
        name: 'GenericTax',
        price: roundPrice(primaryPrice.taxesAndFees),
        priceCurrency: currency,
        priceComponentType: 'GenericTax',
      },
      {
        '@type': SCHEMA_TYPES.UNIT_PRICE_SPECIFICATION,
        name: 'ResortFee',
        price: roundPrice(primaryPrice.propertyFees),
        priceCurrency: currency,
        priceComponentType: 'ResortFee',
      },
    ],
  },
})
